export enum StatStatus {
  Idle = 'Idle',
  Running = 'Running',
  Error = 'Error',
}
